"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const useMediaQuery_1 = __importDefault(require("@material-ui/core/useMediaQuery"));
const AppBar_1 = __importDefault(require("@material-ui/core/AppBar"));
const Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Box_1 = __importDefault(require("../../layouts/Box"));
const clsx_1 = __importDefault(require("clsx"));
const useStyles = styles_1.makeStyles((theme) => ({
    root: {
        height: '65px',
        justifyContent: 'center',
    },
    paddedChildren: {
        '& > *': {
            paddingRight: theme.spacing(1),
        },
    },
    flexGrow: {
        flexGrow: 1,
    },
    title: {
        fontSize: '28px',
        color: theme.palette.primary.contrastText,
    },
    img: {
        verticalAlign: 'middle',
        maxHeight: '42px',
    },
}));
/**
 * A header bar for an application
 */
const Header = ({ title, logoPath, rightContent = null, hideHeaderBelow }) => {
    const classes = useStyles({});
    const theme = styles_1.useTheme();
    const matched = useMediaQuery_1.default(theme.breakpoints.up(hideHeaderBelow || 'sm'));
    return (react_1.default.createElement(AppBar_1.default, { className: classes.root, position: "static", elevation: 0 },
        react_1.default.createElement(Toolbar_1.default, { className: classes.paddedChildren },
            logoPath && (react_1.default.createElement("a", { href: "/" },
                react_1.default.createElement("img", { alt: "Logo", src: logoPath, className: classes.img }))),
            (!hideHeaderBelow || matched) && (react_1.default.createElement(Typography_1.default, { component: "span", className: clsx_1.default(classes.flexGrow, classes.title) }, title)),
            rightContent && react_1.default.createElement(Box_1.default, null, rightContent))));
};
exports.default = Header;
//# sourceMappingURL=index.js.map